import { render, staticRenderFns } from "./addClasses.vue?vue&type=template&id=15c338bf&scoped=true&"
import script from "./addClasses.vue?vue&type=script&lang=js&"
export * from "./addClasses.vue?vue&type=script&lang=js&"
import style0 from "./addClasses.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addClasses.vue?vue&type=style&index=1&id=15c338bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c338bf",
  null
  
)

export default component.exports